//#region Imports
import once from "lodash/once";

//#region config
//#endregion

const GOOGLE_GSI_URL = "https://accounts.google.com/gsi/client";
//#endregion

export const loadGSI = once(() => {
  return new Promise<typeof google>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = GOOGLE_GSI_URL;
    script.async = true;
    script.onerror = reject;
    script.onload = () => resolve(google);

    if (document.head) {
      document.head.appendChild(script);
    } else {
      reject(new TypeError("loadGSI(): document.head isn't declared"));
    }
  });
});
